﻿import React from "react";

class LoadingState extends React.Component {
    render() {
        return (
            <div className={"loadingSpinnerContainer"}>
                <div className={"loadingSpinner"} />
                <p className={"loadingSpinnerText"}>{i18njs["Resource.Search"]}</p>
            </div>
        );
    }
}

export default LoadingState;